import { useCallback } from "react";

/**
 * Handles the click event for the arrow icon.
 * Triggers the checkbox's change handler
 *
 * @param {Object} toggleRef Reference to the DHL checkbox web component
 */
export const useOnArrowClick = (toggleRef) => {
  const toggle = useCallback(() => {
    if (toggleRef?.current) {
      // Get the input from the web component
      const input = toggleRef.current.querySelector('input[type="checkbox"]');
      if (input) {
        // Toggle the checked state
        const newChecked = !input.checked;
        // Update the input
        input.checked = newChecked;
        // Create and dispatch the change event
        const event = new Event("change", { bubbles: true });
        Object.defineProperty(event, "target", { value: input });
        input.dispatchEvent(event);
        // Update the web component's checked attribute by setting attribute directly
        input.parentElement.setAttribute("checked", newChecked);
      }
    }
  }, [toggleRef]);

  return useCallback(
    (event) => {
      event.preventDefault();
      toggle();
    },
    [toggleRef]
  );
};
